export default function loadTextTest(text, loadIndicator = "...") {
    if (text || text === 0)
        return text;
    else
        return loadIndicator;
}